import React, { memo, useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { changeProject, getProject } from '../../../redux/projects/projectsActions';
import { resetEditProjectPage } from '../../../redux/projects/projectsReducer';
import NameSection from '../name/NameSection';
import AccessUsersSection from '../access-users/AccessUsersSection';
import AssignedAssistantsSection from './components/assignedAssistants/AssignedAssistantsSection';
import ShareSection from './components/share/ShareSection';

import scss from './EditScout.module.scss';

const EditScout = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSaveNameSection = ({ id, editProject, values }) => {
    const { projectName } = values;

    dispatch(changeProject({ id, projectType: editProject.projectType, values: { projectName } }));
  };

  useEffect(() => {
    dispatch(getProject({ id }));

    return () => {
      dispatch(resetEditProjectPage());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <NameSection onSubmit={handleSaveNameSection} />
      <ShareSection />
      <AssignedAssistantsSection />
      <AccessUsersSection />
    </div>
  );
};

export default memo(EditScout);
